import { render, staticRenderFns } from "./input-detail.vue?vue&type=template&id=08bc10ea&"
import script from "./input-detail.vue?vue&type=script&lang=js&"
export * from "./input-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports